import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/core/services/settings.service';
import { FormWindowState, SysApiService } from 'src/app/core/services/sysapi.service';

@Component({
  selector: 'layout-header-system-buttom',
  templateUrl: './system-buttom.component.html',
  styleUrls: ['./system-buttom.component.css']
})
export class SystemButtomComponent implements OnInit {

  constructor(
      public sysapi:SysApiService
  ) { }

  ngOnInit(): void {
    
  }

   
}
